import {   useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {  getPortfolios, createPortfolios, getPortfolioDetail, deletePortfolio, updatePortfolio } from "../api";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetPortfolios = () => {
  const {data, isLoading, isError, error, isSuccess} = useQuery({
    queryKey: ['portfolios'],
    queryFn: () => getPortfolios(),
  });

  return {data, isLoading, isSuccess, isError, error};
};

export const useGetPortfolioDetail = (id, enabled = true) => {
  const {data, isLoading, isError, error, isSuccess} = useQuery({
    queryKey: ['portfolio',id],
    queryFn: () => getPortfolioDetail(id),
    enabled: enabled,
  });

  return {data, isLoading, isSuccess, isError, error};
};

export const useCreatePortfolio = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  const mutation = useMutation({
    mutationFn: (data) => createPortfolios(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["portfolios"] });
      showNotification('success', 'Portfolio created successfully!');
      navigate('/portfolios');
    },
    onError: (error) => {
      console.error("Error creating portfolio:", error);
      let errorMessage = 'Error creating portfolio. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      showNotification('danger', errorMessage);
    },
  });

  return mutation;
};

export const useUpdatePortfolio = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();

  const mutation = useMutation({
    mutationFn: ({ id, data }) => updatePortfolio(id, data),
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({ queryKey: ["portfolios"] });
      await queryClient.invalidateQueries({ queryKey: ["portfolio", variables.id] });
      showNotification('success', 'Portfolio updated successfully!');
    },
    onError: (error) => {
      console.error("Error updating portfolio:", error);
      let errorMessage = 'Error updating portfolio. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      showNotification('danger', errorMessage);
    },
  });

  return mutation;
};

export const useDeletePortfolio = () => {
  const queryClient = useQueryClient();
  const { showNotification } = useNotification();
  
  return useMutation({
    mutationFn: (id) => deletePortfolio(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["portfolios"] });
      
      // Show success notification
      showNotification('success', 'Portfolio deleted successfully!');
    },
    onError: (error) => {
      console.error("Error deleting role:", error);
      
      // Show error notification
      let errorMessage = 'Error deleting role. Please try again.';
      if (error?.response?.data?.error?.message) {
        errorMessage = error.response.data.error.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      showNotification('danger', errorMessage);
    },
  });
};